var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"options":_vm._f("listOptions")(_vm.mailWizzes,_vm.selectListFormatter),"size":"sm"},model:{value:(_vm.mailWizz),callback:function ($$v) {_vm.mailWizz=$$v},expression:"mailWizz"}})}
var staticRenderFns = []

export { render, staticRenderFns }